import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageLayout } from "@gravity-ui/navigation";
import { useViewportSize } from "@gravity-ui/uikit";
import { Header } from "@/components/ui/Header";
import { DesktopNavigation, MobileNavigation, useNavigationData, } from "@/components/ui/Navigation";
import { isDesktop, setViewportSize } from "@/store/slices/viewportSlice";
import { ProfileCheckedRoute } from "./ProfileCheckedRoute";
export var DefaultLayout = function () {
    var _a = React.useState(false), compact = _a[0], setCompact = _a[1];
    var switchCompactHandler = function () { return setCompact(function (prev) { return !prev; }); };
    var size = useViewportSize();
    var dispatch = useDispatch();
    useEffect(function () {
        dispatch(setViewportSize(size));
    }, [size.width, size.height]);
    var isDesktopMode = useSelector(isDesktop);
    var navigationItems = useNavigationData().navigationItems;
    return (_jsxs(_Fragment, { children: [isDesktopMode && (_jsxs(PageLayout, { compact: compact, children: [_jsx(DesktopNavigation, { onSwitch: switchCompactHandler, data: navigationItems }), _jsx(PageLayout.Content, { children: _jsx("div", { className: "g-s__p_4", children: _jsx(ProfileCheckedRoute, {}) }) })] })), !isDesktopMode && (_jsxs("div", { className: "g-s__p_4", children: [_jsx(Header, {}), _jsx("div", { style: { paddingTop: 60, paddingBottom: 60 }, children: _jsx(ProfileCheckedRoute, {}) }), _jsx(MobileNavigation, { data: navigationItems })] }))] }));
};
